export default __webpack_public_path__ + "static/communities-2-38caccedf7e0ed310c40ed6fee737ca8.jpg";